import styled from 'styled-components';

const LoadingBox = styled.div`
  width: 48px;
  height: 48px;
  position: absolute;
  top: 50%;
  left: 50%;
  // margin: -24px 0 0 -24px;
  text-align: center;
  color: white;
  font-size: 10px;
  font-weight: bold;
  z-index: 100001;
  transform: translate(-50%, -50%);
`;

const Spinner = () => {
  return (
    <>
      <LoadingBox>
        <img src="/images/loading.svg" width="64" alt="Spinner" />
      </LoadingBox>
    </>
  )
}

export default Spinner;
